import { lazy } from 'react';

// Lazy load de todos los componentes para mejorar el rendimiento
// Solo se cargarán cuando el usuario navegue a esa ruta
const Layout1 = lazy(() => import("./pages/Layout1/Layout_1"));
const HuellaCarbono = lazy(() => import("./pages/HuellaCarbono/HuellaCarbono"));
const DocumentosPage = lazy(() => import("./pages/Documentos/DocumentosPage"));
const AutogestionPage = lazy(() => import("./pages/Autogestion/AutogestionPage"));
const CalculadoraPage = lazy(() => import("./pages/Calculadora/CalculadoraPage"));

const routes = [
  { path: "/huella-carbono", component: <HuellaCarbono /> },
  { path: "/calculadora", component: <CalculadoraPage /> },
  { path: "/documentos", component: <DocumentosPage /> },
  { path: "/autogestion", component: <AutogestionPage /> },
  { path: "/Layout1", component: <Layout1 /> },
  { path: "/", component: <Layout1 /> },
  // Catch-all route: redirige cualquier ruta desconocida a la landing principal
  { path: "*", component: <Layout1 /> },
];

export default routes;
